import React, { useEffect, useState } from 'react'
import { videoApi } from '@services/api'
import ListVideoComponent from './ListVideoComponent'

const limit = 6

const ListVideoGoLiver: React.FC<any> = ({
  id,
  onSelectVideo
}) => {
  const [videos, setVideos] = useState([] as any[])
  const [page, setPage] = useState(1)
  const [hasNextPage, setHasNextPage] = useState(false)
  const [loading, setLoading] = useState(true)
  const [loadingFalse, setLoadingFalse] = useState(true)

  useEffect(() => {
    if (!(page === 1 && videos.length > 0)) {
      fetchVideos()
    }
  }, [page]) // eslint-disable-line react-hooks/exhaustive-deps

  const fetchVideos = async () => {
    try {
      setLoading(true)
      setLoadingFalse(false)
      const params = {
        PageIndex: page,
        PageSize: limit
      }
      const res = await videoApi.getTopPageVideoGoLiver(params)
      if (res && res.success) {
        setVideos([...videos, ...res.data])
        setHasNextPage(res.hasNextPage)
      }
      setLoading(false)
    } catch (error) {
      setLoadingFalse(true)
      setLoading(false)
    }
  }

  const onResetListVideo = () => {
    setPage(1)
    setVideos(videos.slice(0, limit))
    setHasNextPage(true)
  }

  return (
    <>
      <ListVideoComponent
        id={id}
        videos={videos}
        page={page}
        setPage={setPage}
        hasNextPage={hasNextPage}
        loading={loading}
        title={(
          <>
            <i className="bi bi-heart-fill" style={{ fontSize: '25px', color: '#E8541C' }} /> 子連れ歓迎店
          </>
        )}
        onSelectVideo={onSelectVideo}
        onResetListVideo={onResetListVideo}
      />
      {loadingFalse && (
        <span aria-hidden="true" onClick={fetchVideos} className="btn">
          リトライ
        </span>
      )}
    </>
  )
}

export default ListVideoGoLiver
